<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-救援服务-修改
    -->
  <el-dialog
    title="修改救援服务"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >
    <div class="product-add pb50">
      <el-form
        size="small"
        :model="form"
        ref="form"
        :rules="rules"
        label-width="100px"
      >


            <el-form-item label="救援服务名称" prop="name"
          ><el-input
            v-model="form.name"
            placeholder="请输入救援服务名称"
            class="max-w460"
          ></el-input
        ></el-form-item>

        <el-form-item label="电话" prop="phone"
          ><el-input
            v-model="form.phone"
            placeholder="请输入救援服务电话"
            class="max-w460"
          ></el-input
        ></el-form-item>

           <el-form-item label="选择类型" prop="type">
          <el-select
            v-model="form.type"
            filterable
            placeholder="请选择类型"
            style="width: 100%"
        
          >
            <el-option
              v-for="item in typeArr"
              :key="item.val"
              :label="item.name"
              :value="item.val"
            >
            </el-option>
          </el-select>
        </el-form-item>    

         <el-form-item label="擅长" prop="genius"
          ><el-input
            v-model="form.genius"
            placeholder="请输入救援擅长"
            class="max-w460"
          ></el-input
        ></el-form-item>
        <el-form-item label="评级" prop="grade"
          ><el-input
            v-model="form.grade"
            placeholder="请输入救援服务评级"
            class="max-w460"
            type="number"
          ></el-input
        ></el-form-item>

        <el-form-item label="选择救援分类" prop="rescue_service_catalog_id">
          <el-select
            v-model="form.rescue_service_catalog_id"
            filterable
            placeholder="请选择救援分类"
            style="width: 100%"
            :loading="loadingRescueServices"
          >
            <el-option
              v-for="rescueServiceCatalog in rescueServiceCatalogList"
              :key="rescueServiceCatalog.rescue_service_catalog_id"
              :label="rescueServiceCatalog.name"
              :value="rescueServiceCatalog.rescue_service_catalog_id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="审核状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="0">未审核</el-radio>
            <el-radio :label="1">审核通过</el-radio>
            <el-radio :label="2">审核未通过</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="救援服务logo：" prop="model.image">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.image">
              <transition-group>
                <div v-for="(item, index) in form.image" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="file_path" />
                    <a
                      href="javascript:void(0);"
                      class="delete-btn"
                      @click.stop="deleteImg(index, 'album')"
                      ><i class="el-icon-close"></i
                    ></a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('album')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>


          <el-form-item label="资质：" prop="model.zz">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.zz">
              <transition-group>
                <div v-for="(item, index) in form.zz" :key="item.file_path">
                  <div class="item">
             
       
            <el-image 
            
                        :key="index"
                        style="width: 100px; height: 100px; margin-right: 10px"
                        :src="item.file_path"
                        :preview-src-list="[item.file_path]"
                        :initial-index="index"
                        fit="cover">
                      </el-image>


                    <a
                      href="javascript:void(0);"
                      class="delete-btn"
                      @click.stop="deleteImg(index, 'zz')"
                      ><i class="el-icon-close"></i
                    ></a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('zz')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>


             <el-form-item label="身份证正面：" prop="model.idcard_positive">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.idcard_positive">
              <transition-group>
                <div v-for="(item, index) in form.idcard_positive" :key="item.file_path">
                  <div class="item">
             
                                
       
            <el-image 
            
                        :key="index"
                        style="width: 100px; height: 100px; margin-right: 10px"
                        :src="item.file_path"
                        :preview-src-list="[item.file_path]"
                        :initial-index="index"
                        fit="cover">
                      </el-image>
                    <a
                      href="javascript:void(0);"
                      class="delete-btn"
                      @click.stop="deleteImg(index, 'idcard_positive')"
                      ><i class="el-icon-close"></i
                    ></a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('idcard_positive')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>


        

             <el-form-item label="身份证反面：" prop="model.idcard_reverse">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.idcard_reverse">
              <transition-group>
                <div v-for="(item, index) in form.idcard_reverse" :key="item.file_path">
                  <div class="item">
             
                               
       
            <el-image 
            
                        :key="index"
                        style="width: 100px; height: 100px; margin-right: 10px"
                        :src="item.file_path"
                        :preview-src-list="[item.file_path]"
                        :initial-index="index"
                        fit="cover">
                      </el-image>
                    <a
                      href="javascript:void(0);"
                      class="delete-btn"
                      @click.stop="deleteImg(index, 'idcard_reverse')"
                      ><i class="el-icon-close"></i
                    ></a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('idcard_reverse')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>


        <el-form-item label="排序" prop="name"
          ><el-input
            v-model="form.sort"
            placeholder="请输入排序"
            class="max-w460"
          ></el-input
        ></el-form-item>

        <el-tabs v-model="selectMap" @tab-click="handleClick">
          <el-tab-pane label="救援服务地址" name="1">
            <div>
              <el-form-item label="救援服务地址" prop="address">
                <el-input
                  v-model="form.address"
                  placeholder="请输入救援服务地址"
                  class="max-w460"
                ></el-input>
              </el-form-item>
              <el-form-item label="坐标" prop="coordinate">
                <el-row class="mb16">
                  <el-col :span="24">
                    <el-input
                      v-model="form.coordinate"
                      class="max-w460"
                    ></el-input>
                  </el-col>
                </el-row>
                <el-row class="mb16">
                  <el-col :span="24">
                    <Getpoint
                      v-if="selectMap == 1"
                      :form="form"
                      @getMapdata="getMapdataFunc"
                      @chose="choseFunc"
                    ></Getpoint>
                  </el-col>
                </el-row>
              </el-form-item>
            </div>
          </el-tab-pane>
        </el-tabs>

        <!--提交-->
        <div class="common-button-wrapper">
          <el-button size="small" type="info" @click="cancelFunc"
            >取消</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="onSubmit"
            :loading="loading"
            >提交</el-button
          >
        </div>
      </el-form>
      <Upload
        v-if="isProductUpload"
        :config="{ total: 9 }"
        :isupload="isProductUpload"
        @returnImgs="returnProductImgsFunc"
        >上传图片
      </Upload>
      <!-- <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas> -->
    </div>
  </el-dialog>
</template>

<script>
import Rescue_serviceApi from "@/api/rescue_service.js";
import Rescue_service_catalogApi from "@/api/rescue_service_catalog.js";
import Getpoint from "@/components/map/Getpoint.vue";
import Upload from "@/components/file/Upload";
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from "@/components/UE.vue";
export default {
  components: {
    /*图片上传*/
    Upload: Upload,
    Categoryas,
    draggable,
    Uediter,
    Getpoint
  },
  data() {
    return {
      rescueServiceCatalogList: [],
      loadingRescueServices: false,
      selectMap: "1",
      /*是否上传图片*/
      isupload: false,
      isImg: false,
      /*富文本配置*/
      ueditor: {
        text: "",
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        rescue_service_catalog_id: "",
        name: "",
        code: "custom",
        // categorya:{
        //   name:""
        // },
        image: [],
        idcard_reverse:[],
        zz:[],
        idcard_positive:[],
        sort: 50,
        type:"gf"
      },
         typeArr:[
        {
          "val":"gf",
          "name":"官方救援"
        },
           {
          "val":"wxxg",
          "name":"维修小工"
        }

  
      ],
      loading: false,
      /*验证规则*/
      rules: {
        name: [
          { required: true, message: "请输入救援服务名称", trigger: "blur" }
        ]
      },
      dialogVisible: false,
      iscategorya: false,
      excludeIds: [],
      isProductUpload: false,
      code: "album"
    };
  },
  created() {
    console.log(11111);
    this.dialogVisible = this.open_add;
    this.getDetail();
    this.addrescueServiceCatalogList();
  },
  props: ["open_add", "rescue_service_id"],
  methods: {
    addrescueServiceCatalogList() {
      var self = this;
      Rescue_service_catalogApi.listx({}, true)
        .then(data => {
          self.loading = false;
          self.rescueServiceCatalogList = data.data;
          console.log(
            "rescueServiceCatalogList",
            self.rescueServiceCatalogList
          );
        })
        .catch(error => {});
    },
    /*获取经纬度*/
    getMapdataFunc(e) {
      console.log(e);
      this.form.coordinate = e.data[0].toFixed(6) + "," + e.data[1].toFixed(6);
    },

    /*选择的地址*/
    choseFunc(e) {
      this.form.coordinate = e.location.lat + "," + e.location.lng;
      this.form.address = e.address;
    },
    chooseCategory() {
      this.iscategorya = true;
    },
    /*上传*/
    openUpload(e) {
      this.isupload = true;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
        this.form.image = e[0].file_path;
        this.isImg = true;
      }
      this.isupload = false;
    },
    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc() {
      //取消
      this.dialogFormVisible("error");
    },
    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      Rescue_serviceApi.detail(
        { rescue_service_id: self.rescue_service_id },
        true
      )
        .then(res => {
          self.form = res.data;
          self.ueditor.text = self.form.intro;
          self.isImg = true;
          self.loading = false;
          if (!self.form.bannar) {
            self.form.bannar = [];
          }
          if (!self.form.image) {
            self.form.image = [];
          }
        })
        .catch(error => {});
    },
    onSubmit() {
      let self = this;
      let form = self.form;

      form.rescue_service_id = self.rescue_service_id;

      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Rescue_serviceApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: "success"
              });
              self.dialogFormVisible("error");
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消修改，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false, type: "" });
    },
    openProductUpload: function(code) {
      this.isProductUpload = true;
      this.code = code;
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if (this.code == "album") {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          console.log(typeof imgExpt);
          e.forEach(element => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach(e => {
              if (e === ext) {
                prevent = true;
                return false;
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.image.concat(e);
          this.$set(this.form, "image", imgs);
        }
      }else if (this.code == "zz") {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          console.log(typeof imgExpt);
          e.forEach(element => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach(e => {
              if (e === ext) {
                prevent = true;
                return false;
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.zz.concat(e);
          this.$set(this.form, "zz", imgs);
        }
      }else if (this.code == "idcard_positive") {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          console.log(typeof imgExpt);
          e.forEach(element => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach(e => {
              if (e === ext) {
                prevent = true;
                return false;
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.idcard_positive.concat(e);
          this.$set(this.form, "idcard_positive", imgs);
        }
      }else if (this.code == "idcard_reverse") {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          console.log(typeof imgExpt);
          e.forEach(element => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach(e => {
              if (e === ext) {
                prevent = true;
                return false;
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.idcard_reverse.concat(e);
          this.$set(this.form, "idcard_reverse", imgs);
        }
      } else {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          console.log(typeof imgExpt);
          e.forEach(element => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach(e => {
              if (e === ext) {
                prevent = true;
                return false;
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.bannar.concat(e);
          this.$set(this.form, "bannar", imgs);
        }
      }

      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index, code) {
      if (code == "album") {
        this.form.image.splice(index, 1);
      } else if (code == "bannar") {
        this.form.bannar.splice(index, 1);
      }else if (code == "zz") {
        this.form.zz.splice(index, 1);
      }else if (code == "idcard_positive") {
        this.form.bannar.splice(index, 1);
      }else if (code == "idcard_reverse") {
        this.form.idcard_reverse.splice(index, 1);
      }
    }
  }
};
</script>

<style>
.edit_container {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/rescue_service/index/part/edit.vue